<kw-wrapper [wrapperClass]="wrapperClass">
    <ng-container [ngSwitch]="sliderType">
        <ng-container *ngSwitchCase="'row'">
            <kw-title-renderer class="section-title" [title]="title"></kw-title-renderer>
            <ng-container *ngIf="itemsLength > 0">
                <div 
                    slideControl
                    [itemsLength]="itemsLength"
                    [autoStart]="autoStart"
                    #ctrl="slideControl"
                    (selectedIndex)="updateSelectedIndex($event)"
                    (actualIndex)="actualIndex = $event"
                    class="slider-container" [ngClass]="layoutClass">
                        <div class="navigation-wrapper">
                            <div [@sliderAnimation]="{value:sliderAnimation, params:{slidePosition:slidePosition}}" class="slide-track" [ngClass]="layoutClass" #slides>
                                <div class="grid-cell-container slider-item"  *ngFor="let slide of items;let i = index" [id]="'slide-'+i" [attr.cell-id]="slide.cellId">
                                    <div class="item-wrapper">
                                        <div class="image-wrapper">
                                            <img src="{{slide?.imgSrc}}"/>
                                        </div>
                                        <div class="content">
                                    
                                            Slide - {{i}}
                                            </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
               
                    </div>
                    <div
                            class="crtl-prev-container" 
                            [ngClass]="actualIndex == 0 ? 'hide-ctrl': 'display-ctrl'"
                            (click)="ctrl.previous()">
                            <i class="fa fa-angle-left"></i>
                        </div>
                        <div  
                            class="ctrl-next-container" 
                            (click)="ctrl.next()"
                            [ngClass]="itemsLength - actualIndex < numberOfElements-1 ? 'hide-ctrl': 'display-ctrl'">
                            <i class="fa fa-angle-right"></i>
                        </div>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'show'">
            <div class="grid-cell-container slider-item banner"  *ngFor="let slide of slides;let i = index" [id]="'slide-'+i" [attr.cell-id]="slide.cellId">
                <div class="bg-img-layer" [style.--bg-image]="'url(' + slide.imgSrc + ')'"></div>
                    <kw-fill-layer-renderer [fillClass]="slide?.fillClass" [fillColor]="slide?.fillColor"></kw-fill-layer-renderer>
                    <div class="content-layer">
                        <div class="content-layout" [ngClass]="slide?.layoutClass">
                            <div *ngFor="let contentElement of slide?.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </div>
                    </div>
            </div>
        </ng-container>
    </ng-container>
    
    
    
</kw-wrapper>




